module.exports = __webpack_public_path__ + "img/1_ToDust.a8555d70.jpg";